import React from 'react';

import DOMPurify from 'dompurify';
import { componentTypes } from '@white-nl/instantsearch-components';
import Picture from '../../../ui/Picture';
import {
  ArrowRightSharpRegular,
} from '../../../ui/icons';

export default function Hit({ hit, results }: componentTypes.HitProps) {
  const {
    title,
    label,
    applicationsLabels,
    countries,
    image,
    imageLarge,
    url,
  } = hit;

  const isFirst = results.hits[0].objectID === hit.objectID;

  return (
    <div className={isFirst ? 'col-12' : 'col-12 col-md-6'}>
      <a className="card-visual ratio ratio-16x9 small" href={url}>
        <div className="card-visual-img">
          <Picture image={isFirst ? imageLarge : image} defaultTransform="xxl-min" loading="lazy" />
        </div>
        <div className="card-visual-body">
          <div className="card-visual-arrow">
            <ArrowRightSharpRegular />
          </div>
          <div className="wrap-badge">
            {label ? (
              <span className="badge bg-danger">{label}</span>
            ) : applicationsLabels && (
              applicationsLabels.title.map((application: string) => (
                <span key={application} className="badge bg-danger">{application}</span>
              ))
            )}
          </div>
          <div>
            {countries && (
              <span className="sub-title">{countries.title.join(', ')}</span>
            )}
            <h2
              className="h2"
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(title) }}
            />
          </div>
        </div>
      </a>
    </div>
  );
}
